import { QueryClient } from '@tanstack/react-query'
import { isAxiosError } from 'axios'
import { toast } from 'react-hot-toast'

export const fireErrorNotification = (err: unknown) => {
    let errorMessage = 'Something went wrong.'

    if (isAxiosError(err)) {
        const errors = err?.response?.data?.errors

        // Catch image uploads that are too large
        if (err.status === 413) {
            errorMessage = 'Image too large, max file size for image uploads is 8 MB.'
        } else if (Array.isArray(errors) && typeof errors[0] === 'string') {
            errorMessage = errors[0]
        } else if (typeof errors === 'object') {
            const first = Object.values(errors)[0]
            if (Array.isArray(first) && typeof first[0] === 'string') {
                errorMessage = first[0]
            }
        } else if (err.status === 422) {
            errorMessage = 'Unable to process image.'
        }
    }

    toast.error(errorMessage)
}

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            retry: false,
            // Defaults to 0. If 0, duplicate queries will always refetch the data even if it already exists
            staleTime: 1000 * 60 * 5,
            networkMode: 'always'
        },
        mutations: {
            onError: (err) => {
                fireErrorNotification(err)
            },
            networkMode: 'always'
        }
    }
})
